(function (upp) {
    'use strict';

    var _storage;

    /**
     * Route interceptor intercepts a route change and performs operations when that happens
     * @param {Function} fn A function with two parameters: current (current route), prev (previous route)
     * @constructor
     */
    var Interceptor = function (fn) {
        this.fn = fn;
    };

    /**
     * Intercept the routes and perform the operations
     * @param {String} current Current route
     * @param {String} prev Previous route
     */
    Interceptor.prototype.intercept = function (current, prev) {
        this.fn(current, prev);
    };

    // Route interceptor filter
    // To add a new route interceptor, just push a new interceptor to the interceptors array
    upp.service('routeInterceptorService', ['storage', function (storage) {
        _storage = storage;
        var interceptors = [];

        return {
            intercept: function (current, prev) {
                for (var i = 0, len = interceptors.length; i < len; i++) {
                    interceptors[i].intercept(current, prev);
                }
            }
        };
    }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/common/services/route-interceptor-service.js